document.addEventListener("DOMContentLoaded", () => {
    const productForm = document.querySelector(".ProductForm");
    if (!productForm) return;

    const productJsonEl = document.querySelector("[data-product-json]");
    if (!productJsonEl) return;
    const productData = JSON.parse(productJsonEl.textContent);
    const swatchInputs = document.querySelectorAll(".swatch-input__input");
    const priceEl = document.querySelector(".Product__Price");
    const submitBtn = document.querySelector("#ProductFormSubmitBtn");
    const variantInput = productForm.querySelector('input[name="id"]');

    const flickityEl = document.querySelector(".Product__Slideshow");
    let flickityInstance = null;

    let isAdding = false;
    if (!submitBtn || !productForm || !variantInput) return;
    const waitForImagesAndInitFlickity = () => {
        if (!flickityEl) return;

        const images = flickityEl.querySelectorAll("img");
        let loaded = 0;

        const checkLoaded = () => {
            loaded++;
            if (loaded === images.length) {
                flickityInstance = new Flickity(flickityEl, {
                    wrapAround: true,
                    adaptiveHeight: true,
                    pageDots: true,
                    prevNextButtons: false,
                    lazyLoad: false,
                });

                setTimeout(() => flickityInstance.resize(), 200);
            }
        };

        images.forEach((img) => {
            if (img.complete) {
                checkLoaded();
            } else {
                img.addEventListener("load", checkLoaded);
                img.addEventListener("error", checkLoaded);
            }
        });
    };

    waitForImagesAndInitFlickity();

    const navItems = document.querySelectorAll(".Product__NavItem");

    navItems.forEach((btn) => {
        btn.addEventListener("click", () => {
            const index = parseInt(btn.dataset.target, 10);

            if (flickityInstance) {
                flickityInstance.select(index);
                flickityInstance.resize();
            }

            navItems.forEach((b) => b.classList.remove("is-active"));
            btn.classList.add("is-active");
        });
    });

    if (flickityInstance) {
        flickityInstance.on("change", (index) => {
            navItems.forEach((b) => b.classList.remove("is-active"));
            const active = document.querySelector(
                `.Product__NavItem[data-target="${index}"]`
            );
            if (active) active.classList.add("is-active");
        });
    }

    const updateGallerySlide = (variant) => {
        if (!variant || !flickityInstance) return;

        const mediaId = variant.featured_media?.id;
        if (!mediaId) return;

        const slides = flickityEl.querySelectorAll(".Product__Slide");
        let indexToSelect = 0;

        slides.forEach((slide, index) => {
            if (slide.dataset.mediaId == String(mediaId)) indexToSelect = index;
        });

        flickityInstance.select(indexToSelect);
        setTimeout(() => flickityInstance.resize(), 150);
    };

    const updatePrice = (variant) => {
        if (!priceEl || !variant) return;

        priceEl.textContent = `$${(variant.price / 100).toFixed(2)} MXN`;
    };

    const updateAddToCartState = (variant) => {
        if (!submitBtn) return;

        if (variant && variant.available) {
            submitBtn.disabled = false;
            submitBtn.querySelector("span").textContent = "Agregar al carrito";
        } else {
            submitBtn.disabled = true;
            submitBtn.querySelector("span").textContent = "Agotado";
        }
    };

    const getSelectedVariant = () => {
        const selectedOptions = [];

        swatchInputs.forEach((input) => {
            if (input.checked) {
                selectedOptions.push(input.dataset.variantTitle.trim());
            }
        });

        return productData.variants.find((v) => {
            return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });
    };

    swatchInputs.forEach((input) => {
        input.addEventListener("change", () => {
            swatchInputs.forEach((radio) => {
                const label = document.querySelector(
                    `label[for="${radio.id}"]`
                );
                if (label) label.classList.remove("menu-checked-option");
            });

            const selectedLabel = document.querySelector(
                `label[for="${input.id}"]`
            );
            if (selectedLabel)
                selectedLabel.classList.add("menu-checked-option");

            const variant = getSelectedVariant();
            if (!variant) return;

            updateGallerySlide(variant);
            updatePrice(variant);
            updateAddToCartState(variant);

            // 🔥 ACTUALIZAR VARIANT ID DEL FORM
            if (variantInput) variantInput.value = variant.id;
        });
    });

    const initialVariant = getSelectedVariant();
    if (initialVariant) {
        updateGallerySlide(initialVariant);
        updatePrice(initialVariant);
        updateAddToCartState(initialVariant);
    }

    async function addToCartSafe(variantId, quantity = 1) {
        if (isAdding) return;
        isAdding = true;

        // Deshabilitar botón
        submitBtn.disabled = true;
        submitBtn.classList.add("is-loading");
        submitBtn.querySelector("span").textContent = "Agregando...";

        try {
            const res = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity,
                }),
            });

            if (!res.ok) {
                let err = null;
                try {
                    err = await res.json();
                } catch (e) {}

                console.error("❌ Error Shopify:", err || res.status);

                throw new Error(
                    err?.description || "No se pudo agregar al carrito"
                );
            }

            const item = await res.json();
            return item;
        } finally {
            // Rehabilitar botón después de 1 segundo
            setTimeout(() => {
                isAdding = false;
                submitBtn.disabled = false;
                submitBtn.classList.remove("is-loading");
                submitBtn.querySelector("span").textContent =
                    "Agregar al carrito";
            }, 1000);
        }
    }
    productForm.addEventListener("submit", async (e) => {
        e.preventDefault();

        const variantId = variantInput.value;
        if (!variantId || variantId.trim() === "") {
            console.error("❌ variant_id vacío → 422 seguro");
            alert("Selecciona una variante antes de agregar.");
            return;
        }

        try {
            const item = await addToCartSafe(variantId, 1);
            console.log("✅ Agregado:", item);

            // Actualizar minicart
            if (typeof actualizarCarrito === "function") {
                await actualizarCarrito();
            }

            // Abrir sidebar-cart
            if (typeof openSidebar === "function") {
                openSidebar();
            }
        } catch (error) {
            console.error("🔥 Error:", error);
            alert(error.message || "No se pudo agregar al carrito.");
        }
    });
    (function () {
        var accordion_product = document.querySelector("#accordionProduct");
        if (!accordion_product) return;

        var tabs_menu_product =
            accordion_product.getElementsByClassName("accordion-header");

        // Asignar evento a cada header
        for (var i = 0; i < tabs_menu_product.length; i++) {
            tabs_menu_product[i].addEventListener(
                "click",
                js_accordion_product
            );
        }

        function js_accordion_product(event) {
            event.preventDefault();

            var content = this.nextElementSibling;

            if (this.classList.contains("active-accordion")) {
                hide_active_tab_product();
                content.style.display = "none";
                content.classList.remove("animation_acrd", "fadeIn");
            } else {
                var tabs_panel =
                    accordion_product.getElementsByClassName(
                        "accordion-content"
                    );

                // Ocultamos todos los panels
                for (var k = 0; k < tabs_panel.length; k++) {
                    tabs_panel[k].style.display = "none";
                    tabs_panel[k].classList.remove("animation_acrd", "fadeIn");
                }

                hide_active_tab_product();

                // Activar el nuevo
                this.classList.add("active-accordion");
                content.classList.add("animation_acrd", "fadeIn");
                content.style.display = "block";
            }
        }

        function hide_active_tab_product() {
            for (var j = 0; j < tabs_menu_product.length; j++) {
                tabs_menu_product[j].classList.remove("active-accordion");
            }
        }
    })();
});
